import { render, staticRenderFns } from "./ChargeAccount.vue?vue&type=template&id=1dd4d493&scoped=true&"
import script from "./ChargeAccount.vue?vue&type=script&lang=ts&"
export * from "./ChargeAccount.vue?vue&type=script&lang=ts&"
import style1 from "./ChargeAccount.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd4d493",
  null
  
)

export default component.exports